import { render, staticRenderFns } from "./InnerEnvelopeBatch.vue?vue&type=template&id=f2d77fd0&scoped=true"
import script from "./InnerEnvelopeBatch.vue?vue&type=script&lang=js"
export * from "./InnerEnvelopeBatch.vue?vue&type=script&lang=js"
import style0 from "./InnerEnvelopeBatch.vue?vue&type=style&index=0&id=f2d77fd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d77fd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
